module["exports"] = [
  "zu",
  "von",
  "vom",
  "von der"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de/name/nobility_title_prefix.js
// module id = 617
// module chunks = 0